import {
	Aside,
	Content,
	Grid,
	Section,
	SectionHeading,
	HeroCard,
	Heading,
	StarRating,
	Eyebrow,
	Button,
} from '@keahotels/components';
import useTranslation from 'next-translate/useTranslation';
import { useSettings } from '../AppLayout/AppLayout';
import HotelLogo from '../HotelLogo/HotelLogo';
import Link from '../Link/Link';
import Image from '../Image/Image';

import { ReactComponent as NorthEast } from '@keahotels/assets/icons/NorthEast.svg';
import styles from './HotelFallbackHeader.module.css';
import { ImageFragment } from '../Image/__generated__/ImageFragment';
import Video from '../Video/Video';

export type HotelFallbackHeaderProps = {
	title?: string | null;
	eyebrow?: string | null;
};

export default function HotelFallbackHeader({
	title,
	eyebrow = 'Nothing that fits your needs?',
}: HotelFallbackHeaderProps) {
	const { t } = useTranslation('common');
	const { hotelSettings } = useSettings();
	let image: any = null;
	let video: any = null;
	if (hotelSettings?.header?.slider?.__typename === 'MainHeaderImage') {
		image = hotelSettings?.header?.slider.image;
	} else if (
		hotelSettings?.header?.slider?.__typename === 'MainHeaderImageSlider'
	) {
		image = hotelSettings?.header?.slider.images[0].image;
	} else if (
		hotelSettings?.header?.slider?.__typename === 'MainHeaderVideo'
	) {
		video = hotelSettings?.header?.slider.video;
	}

	return (
		<>
			<Grid className={styles.topWrap}>
				<Aside left>
					<Link
						href={hotelSettings?.uri || '#'}
						className={styles.logo}
					>
						<HotelLogo />
					</Link>
				</Aside>
				<div className={styles.content}>
					<Section
						heading={<SectionHeading>{eyebrow}</SectionHeading>}
					/>
					<h2 className={styles.contentHeader}>
						{title || 'Check out our sister hotel'}
					</h2>
				</div>
			</Grid>
			<Link href={hotelSettings?.uri || '#'} className={styles.content}>
				<HeroCard
					image={
						image ? (
							<Image aspectRatio="square" {...image} />
						) : video ? (
							<Video
								aspectRatio="square"
								src={`${process.env.NEXT_PUBLIC_IMAGE_URL}/wp-content/uploads/${video.uri}`}
								autoPlay
								loop
							/>
						) : null
					}
					className={styles.heroCard}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							height: '100%',
						}}
					>
						<Heading
							as="h3"
							wrapperClassName={styles.heading}
							eyebrow={
								<Eyebrow>
									{hotelSettings?.stars ? (
										<StarRating
											stars={hotelSettings.stars}
											aria-label={t(
												`starRatingAria_${hotelSettings.stars}`,
												{
													hotelName:
														hotelSettings?.title,
												},
											)}
										/>
									) : undefined}
								</Eyebrow>
							}
						>
							{hotelSettings?.title}
						</Heading>
						<hr className={styles.divider} />
						{hotelSettings?.intro && (
							<div
								dangerouslySetInnerHTML={{
									__html: hotelSettings?.intro,
								}}
							/>
						)}
						<Button
							as="div"
							variant="clear"
							icon={<NorthEast />}
							style={{ marginTop: 'auto' }}
						>
							{t('readMore')}
						</Button>
					</div>
				</HeroCard>
			</Link>
		</>
	);
}
